module.exports = __webpack_public_path__ + "static/media/input_data_template.e43b4524.csv";